<template>



            <div class="container" >


                    <nav class="level">
                        <div class="level-left">
                            <div class="level-item">
                                <b-field label="Select Date" :type="{ 'is-danger': hasError }"
                                         :message="{ 'date is not available': hasError }">
                                    <b-datepicker v-model="date_selected"
                                                  placeholder="Click to select..."
                                                  icon="calendar-today"
                                                  range
                                    >
                                    </b-datepicker>
                                </b-field>
                            </div>
                            <div class="level-item">
                                <b-field label="#">
                                    <b-button type="is-primary is-light">Get Report</b-button>
                                </b-field>
                            </div>
                            <div class="level-item">
                                <b-field label="Clear">
                                    <b-button type="is-danger is-light">Clear</b-button>
                                </b-field>
                            </div>



                        </div>
                        <div class="level-right">
                            <div class="level-item">
                                <div class="level-item">
                                    <b-field label="Back">
                                        <b-button type="is-success" @click="closeModal">Back To Dashboard Report</b-button>
                                    </b-field>
                                </div>
                            </div>
                        </div>
                    </nav>

                    <hr>


                    <template>

                        <b-table
                                :data="isEmpty ? [] : dataWorkload"
                                bordered
                                striped
                                narrowed
                                hoverable
                                focusable
                                mobile-cards>

                            <b-table-column   label="ID"  v-slot="props">
                                {{ props.row.id }}
                            </b-table-column>

                            <b-table-column   label="Pathologist" v-slot="props">
                                {{ props.row.name }}
                            </b-table-column>

                            <b-table-column   label="Cytology" v-slot="props">
                                {{ props.row.Cytology }}
                            </b-table-column>

                            <b-table-column   label="Biopsy" v-slot="props">
                                {{ props.row.Biopsy }}
                            </b-table-column>

                            <b-table-column   label="Micrology" v-slot="props">
                                {{ props.row.Micrology }}
                            </b-table-column>


                            <b-table-column   label="PCR" v-slot="props">
                                {{ props.row.PCR }}
                            </b-table-column>

                        </b-table>

                    </template>

            </div>


</template>

<script>
    import { getRandomFloat , getRandomInt } from '@/utils.js'
    export default {
        name: "Report002",
        methods:{
            closeModal(){
               this.$emit('close')
            },
            getRandomFloatSample(){
                return getRandomFloat()
            },
            getRandomIntSample(){
                return getRandomInt()
            }
        },
        computed:{

        },
        data(){
           return {
               date_selected : null,
               isEmpty: false,
               dataWorkload:[
                   {"id": 1 , "name": "Joanne", "Cytology": 13 , "Biopsy": 2 , "Micrology" : 2 , "PCR": 5 },
                   {"id": 2 , "name": "Julia", "Cytology": 3 , "Biopsy": 6 , "Micrology" : 4 , "PCR": 5 },
                   {"id": 3 , "name": "Theresa", "Cytology": 4 , "Biopsy": 3 , "Micrology" : 4 , "PCR": 5 },
                   {"id": 4 , "name": "Ruth", "Cytology": 9 , "Biopsy": 2 , "Micrology" : 2 , "PCR": 5 },
                   {"id": 5 , "name": "Samantha", "Cytology": 34 , "Biopsy": 6 , "Micrology" : 6 , "PCR": 3 },
                   {"id": 6 , "name": "Blake", "Cytology": 3 , "Biopsy": 2 , "Micrology" : 6 , "PCR": 4 },
                   {"id": 7 , "name": "Allan", "Cytology": 45 , "Biopsy": 3 , "Micrology" : 62 , "PCR": 5 },
                   {"id": 8 , "name": "Phil", "Cytology": 8 , "Biopsy": 8 , "Micrology" : 2 , "PCR": 6 },
                   {"id": 9 , "name": "Ellison", "Cytology": 4 , "Biopsy": 3 , "Micrology" : 6 , "PCR": 3 },
                   {"id": 10 , "name": "Brian", "Cytology": 7 , "Biopsy": 5 , "Micrology" : 45 , "PCR": 21 },
                   {"id": 11 , "name": "Mitchell", "Cytology": 23 , "Biopsy": 7 , "Micrology" : 6 , "PCR": 5 },
                   {"id": 12 , "name": "Vaughan", "Cytology": 55 , "Biopsy": 3 , "Micrology" : 4 , "PCR": 5 },
                   {"id": 13 , "name": "White", "Cytology": 2 , "Biopsy": 7 , "Micrology" : 2 , "PCR": 6 },
                   {"id": 14 , "name": "Boris", "Cytology": 89 , "Biopsy": 2 , "Micrology" : 5 , "PCR": 5 },
                   {"id": 15 , "name": "McLean", "Cytology": 5 , "Biopsy": 8 , "Micrology" : 5 , "PCR": 45 },
                   {"id": 16 , "name": "Dyer", "Cytology": 6 , "Biopsy": 4 , "Micrology" : 6 , "PCR": 4 },
                   {"id": 17 , "name": "Wilson", "Cytology": 4 , "Biopsy": 9 , "Micrology" : 5 , "PCR": 5 },
                   {"id": 18 , "name": "Duncan", "Cytology": 2 , "Biopsy": 22 , "Micrology" : 3 , "PCR": 45 },
                   {"id": 19 , "name": "Victor", "Cytology": 23 , "Biopsy": 2 , "Micrology" : 2 , "PCR": 5 },
                   {"id": 20 , "name": "Keith", "Cytology": 3 , "Biopsy": 21 , "Micrology" : 4 , "PCR": 75 },
               ]
           }
        }
    }
</script>

<style scoped>

</style>